import _ from 'lodash';
import moment from 'moment';

let PRODUCTS_SELECTOR_TABS = [{
  assign: {
    options: {
      searchLabel: 'product name',
      tabName: 'products',
      uri: '/products',
      dataSet: 'entitler',
      fetchMethod: 'fetchProductsByCustomer'
    },
    columns: [
      {
        name: 'name',
        label: 'PRODUCTS_NAME_LABEL',
        type: 'table-grid-radio-cell',
        isSortable: true
      },
      {
        name: 'seatsAssigned',
        label: 'SEATS_ASSIGNED',
        type: 'table-grid-icon-extended-cell',
        isSortable: true,
        extendedConfig: {
          value: (row) => {},
          icon: (row) => {
            if (row.seatsAssigned && row.platform.toLowerCase() === 'connected') {
              if (row.seatsAssigned > 0){
                return {
                  class: 'alert-success-icon',
                };
              }
            }
            else if (row.platform.toLowerCase() === 'connected') {
              return '0'
            }
            else if (row.seatsAssigned && row.platform.toLowerCase() != 'connected') {
              return {
                class: 'alert-success-icon',
              };
            }
            else {
              return ''
            }
          }
        }
      }
    ]
  }
}, {
  manage: {
    options: {
      tabName: 'products',
      uri: '/products',
      dataSet: 'entitler',
      searchLabel: 'product name',
      fetchMethod: 'fetchProductsByCustomer'

    },
    columns: [{
      name: 'name',
      label: 'PRODUCTS_NAME_LABEL',
      type: 'table-grid-radio-cell',
      isSortable: true
    }, {
      name: 'seatsPurchased',
      label: 'PRODUCTS_SEATS_PURCHASED_LABEL',
      type: 'table-grid-text-cell',
      isSortable: true
    }, {
      name: 'seatsAssigned',
      label: 'PRODUCTS_SEATS_ASSIGNED_LABEL',
      isSortable: true,
      validation: {
        value: function (row) {
          const openLearningProducts = ['openlearning', 'redbird', 'aleks', 'studysync', 'lars', 'apr', 'al', 'a3k', 'a3k_math', 'a3k_literacy'];
          const isOpenLearningProducts = _.includes(openLearningProducts, (row.platform ? row.platform.toLowerCase() : ''));

          if (!isOpenLearningProducts) {
            const licencesExceededBy = row.seatsAssigned - row.seatsPurchased;
            if (licencesExceededBy > 0) {
              return '+' + licencesExceededBy;
            }
          }
        },
        class: 'error'
      },
      type: 'table-grid-validation-cell'
    }, {
      name: 'edition',
      label: 'PRODUCTS_EDITION_LABEL',
      formatFilter: 'fullEdition',
      type: 'table-grid-text-cell',
      isSortable: true
    }, {
      name: 'expiry',
      label: 'PRODUCTS_EXPIRY_DATE_LABEL',
      formatFilter: 'maxPrettifyDate',
      type: 'table-grid-text-cell',
      isSortable: true
    }]
  }
},
{
  'aleks-master-templates': {
    options: {
      searchLabel: 'ALEKS Master Template Name',
      tabName: 'aleks-master-templates',
      uri: '/aleks-master-templates',
      dataSet: 'entitler',
      fetchMethod: 'fetchALEKSMasterTemplatesByProduct'
    },
    columns: [{
      name: 'name',
      label: 'ALEKS_NAME_LABEL',
      type: 'table-grid-radio-cell',
      // isSortable: false
    },
    {
      name: 'courseProduct',
      label: 'ALEKS_COURSE_PRODUCT',
      type: 'table-grid-text-cell',
      // isSortable: false
    },
    {
      name: 'grade',
      label: 'ALEKS_GRADE',
      type: 'table-grid-text-cell',
      // isSortable: true
    },
    {
      name: 'startDate',
      label: 'ALEKS_START_DATE',
      type: 'table-grid-text-cell',
      // isSortable: true
      virtualAttribute: (row) => {
        if (row.startDate) {
          return moment(row.startDate).format('YYYY-MM-DD');
        }
        return '';
      }
    },
    {
      name: 'endDate',
      label: 'ALEKS_END_DATE',
      type: 'table-grid-text-cell',
      // isSortable: true
      virtualAttribute: (row) => {
        if (row.endDate) {
          return moment(row.endDate).format('YYYY-MM-DD');
        }
        return '';
      }
    },
    {
      name: 'aleksMasterTemplateId',
      label: 'ALEKS_CLASS_CODE',
      type: 'table-grid-text-cell',
      // isSortable: true
    },
    {
      name: 'status',
      label: 'ALEKS_STATUS',
      type: 'table-grid-icon-extended-cell',
      // isSortable: true
      extendedConfig: {
        value: (row) => {},
        icon: (row) => {
          if (row.endDate && moment(row.endDate).isBefore(moment(), 'day')) {
            if (row.isArchived) {
              return {
                class: 'alert-danger-icon',
                tooltipText: 'Expired & Archived'
              };
            }
            return {
              class: 'alert-danger-icon',
              tooltipText: 'Expired'
            };
          }
          if (row.isArchived) {
            return {
              class: 'alert-warning-icon',
              tooltipText: 'Archived'
            };
          }
          return {
            class: 'alert-success-icon',
            tooltipText: 'Active'
          };
        }
      }
    },
    ]
  }
},
{
  resource: {
    options: {
      searchLabel: 'resource name',
      tabName: 'resources',
      uri: '/resources',
      dataSet: 'entitler',
      fetchMethod: 'fetchResourcesByProduct'
    },
    columns: [{
      name: 'name',
      label: 'RESOURCE_NAME_LABEL',
      type: 'table-grid-radio-cell',
      isSortable: true
    }]
  }
}];

export default PRODUCTS_SELECTOR_TABS;



// WEBPACK FOOTER //
// ./app/models/productsSelectorTabs.js